import { render, staticRenderFns } from "./Fish2.vue?vue&type=template&id=5a3b5a65&"
import script from "./Fish2.vue?vue&type=script&lang=js&"
export * from "./Fish2.vue?vue&type=script&lang=js&"
import style0 from "./Fish2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports